import React, { useRef, useState } from 'react'
import { Grid, Typography, Grow } from '@mui/material'
import useStyles from './style'
import { API_ENDPOINTS } from 'constants'
import _ from 'lodash'
import VisibilitySensor from 'react-visibility-sensor'

// const list = [
//   {
//     id: 1,
//     img: '/assets/images/delivery/ship.png',
//     label: 'Free Shipping',
//     description: `Free shipping over ₹ 2000`,
//   },
//   {
//     id: 2,
//     img: '/assets/images/delivery/support.png',
//     label: 'Support 24/7',
//     description: 'Contact us 24 hours a day',
//   },
//   {
//     id: 3,
//     img: '/assets/images/delivery/money.png',
//     label: '100% Money Back',
//     description: 'You have 7 days to Return',
//   },
//   {
//     id: 4,
//     img: '/assets/images/delivery/secure.png',
//     label: 'Payment Secure',
//     description: 'We ensure secure payment',
//   },
// ]

const DeliveryProcess = (props) => {
  const { deliveryProcess } = props
  const classes = useStyles()
  const [isVisible, setIsVisible] = useState(false)

  const onVisibilityChange = (isVisible) => {
    setIsVisible(isVisible)
  }

  return (
    <>
      {!_.isEmpty(deliveryProcess) ? (
        <Grid container className={classes.root}>
          {/* <VisibilitySensor onChange={onVisibilityChange}> */}
          <Grid item xs={12}>
            <section className={classes.wrapper}>
              {deliveryProcess?.map((data) => (
                <Grid xs={12} sm={6} md={3} lg={2.4} key={data?._id}>
                  {/* <Grow in={isVisible} timeout={1500}> */}
                  <section className={classes.processWrapper}>
                    <img
                      src={API_ENDPOINTS?.FILE_URL + data?.image}
                      alt={data?.label}
                      className={classes.img}
                    />
                    <div>
                      <div className={classes.title}>
                        <Typography variant="body1">{data?.title}</Typography>
                      </div>
                      <div className={classes.content}>
                        <Typography variant="body1">{data?.content}</Typography>
                      </div>
                    </div>
                  </section>
                  {/* </Grow> */}
                </Grid>
              ))}
            </section>
          </Grid>
          {/* </VisibilitySensor> */}
        </Grid>
      ) : (
        <></>
      )}
    </>
  )
}

export default DeliveryProcess
